<ng-container *transloco="let convert;">
<trap-focus
  [enableFocusTrap]="true"
  [enableArrowKeys]="true"
>
  <app-modal
    data-test-id="revoke-text-message-consent-modal-container"
    [modalId]="modalId"
    class="modal--revoke-text-message-consent"
  >
    <ng-container>

      <header
        class="modal__header mb-2"
      >
        <h1
          data-test-id="revoke-text-message-consent-modal-title"
          class="modal__title text-bold"
          id="revoke-text-message-consent-modal-title"
          tabindex="-1"
        >
          {{convert('profileManagement.revokeTextMessageConsentMoidal.title')}}
        </h1>
      </header>

      <div class="modal__subheader">
        <p data-test-id="revoke-text-message-consent-modal-subheader">
          {{convert('profileManagement.revokeTextMessageConsentMoidal.subHeader')}}
        </p>
      </div>

      <div class="modal__content">
        <div class="modal__body">
          <div
            class="modal__actions"
          >
            <ng-container>
              <button
                data-test-id="revoke-text-message-consent-modal-revoke-button"
                class="btn btn-danger me-md-2 mb-3 mb-md-0 me-2"
                (click)="revoke()"
                data-track-elem="button"
                data-track-name="Revoke"
              >
                {{convert('profileManagement.revokeTextMessageConsentMoidal.btnContinue')}}
              </button>
              <button
                data-test-id="revoke-text-message-consent-modal-cancel-button"
                class="btn btn-link cancel-btn me-md-2 mb-3 mb-md-0"
                (click)="cancel()"
                data-track-elem="button"
                data-track-name="Cancel"
              >
                {{convert('common.btnCancel')}}
              </button>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="modal-close-container">
        <button
          data-test-id="revoke-text-message-consent-modal-close-button"
          id="bm_close_x_button"
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="close()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
        >
          <i
            class="allycon-glyph-close text-primary"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </ng-container>

  </app-modal>
</trap-focus>
</ng-container>
